
export const numberFormatBR = (number: any) => {
    let value = number.toString();

    value = value.replace(/\D/g, "") // permite digitar apenas numero
    value = value.replace(/(\d{1})(\d{12})$/, "$1.$2") // coloca ponto antes dos ultimos digitos
    value = value.replace(/(\d{1})(\d{9})$/, "$1.$2") // coloca ponto antes dos ultimos 11 digitos
    value = value.replace(/(\d{1})(\d{6})$/, "$1.$2") // coloca ponto antes dos ultimos 8 digitos
    value = value.replace(/(\d{1})(\d{3})$/, "$1.$2") // coloca ponto antes dos ultimos 5 digitos

    return value;
}

export const convertToFloat = (value: any) => {
    return value.toString().replace('.','').replace(',', '.');
}

export const convertFromFloat = (value: any) => {
    return value.toString().replace('.',',');
}

export const currencyFormatToBR = (value: any, fractionDigits?: number) => {
    let valueWithoutComma = Math.round((value + Number.EPSILON) * 100) / 100;
    let formatedValue = valueWithoutComma
        .toFixed(fractionDigits ? fractionDigits : 2)
        .replace('.', ',');
    return formatedValue.substring(0,formatedValue.indexOf(',')).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + formatedValue.substring(formatedValue.indexOf(','))
};

export const currencyFormat4DigitsToBR = (value: any, fractionDigits?: number) => {
    let valueWithoutComma = Math.round((value + Number.EPSILON) * 10000) / 10000;
    let formatedValue = valueWithoutComma
        .toFixed(fractionDigits ? fractionDigits : 2)
        .replace('.', ',');
    return formatedValue.substring(0,formatedValue.indexOf(',')).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + formatedValue.substring(formatedValue.indexOf(','))
};